// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerClickableStyles } from "@eisinc/App/Components/Header/HeaderClickable";
import { HEADER_BREAKPOINT } from "@eisinc/Overrides/Pages/Header";
import ChevronDown from "@eisinc/XDL/Icons/ChevronDown";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xScreen } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

const sharedCompactClickableStyles = css`
    min-width: initial;
    flex-direction: row;
`;

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${({ isHorizontal }: any) => isHorizontal && sharedCompactClickableStyles}
    `,
};

headerClickableStyles.iconWrapper = {
    css: css`
        display: flex;
    `,
};

headerClickableStyles.icon = {
    size: 26,
    color: "common.ui5",
};

headerClickableStyles.title = {
    size: fontConfig.singleLineSmall.size,
    weight: fontConfig.weight.medium,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    color: "text.main",
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        text-align: center;
        white-space: nowrap;
        ${xScreen("lte", HEADER_BREAKPOINT)} {
            display: none;
            ${({ isCheckoutPage }: any) => isCheckoutPage && css`
                &&& {
                    display: initial;
                    ${IconWrapper} {
                        display: none;
                    }
                }
            `}
        }


            
    `,
};

headerClickableStyles.arrowIcon = {
    src: ChevronDown,
    size: 12,
    color: "common.ui5",
    css: css`
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        &.opened {
            transform: rotate(180deg);
        }
    `,
};
